import { Flex } from '@pancakeswap/uikit'
import { socialList } from '@pancakeswap/uikit/src/util/dackieSocials'
import Link from 'next/link'
import React from 'react'
import styled from 'styled-components'
import { dackieColors } from 'utils/dackieConfigs'

const DackiePartnerSocial = (props: { gap?: number; flexStyle?: React.CSSProperties; isDark: boolean}) => {
  const { gap = 20, flexStyle, isDark } = props
  return (
    <IconListWrapper
      style={{
        gap,
        height: '100%',
        ...flexStyle,
      }}
    >
      {socialList.map((item, idx) => {
        const Icon = item.src
        if (item.title === 'galxe') {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <IconWrapper key={idx} href={item?.to} legacyBehavior>
              <a className="icon-linking" target="_blank" href={item.to} rel="noopener noreferrer">
                <Icon
                  style={{
                    background: dackieColors.black,
                    borderRadius: '100%',
                    padding: 2,
                  }}
                />
              </a>
            </IconWrapper>
          )
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          <IconWrapper key={idx} href={item?.to} legacyBehavior>
            <a className="icon-linking" target="_blank" href={item.to} rel="noopener noreferrer">
              <Icon color={isDark ? "#fff" : "#000"} />
            </a>
          </IconWrapper>
        )
      })}
    </IconListWrapper>
  )
}

export default DackiePartnerSocial

const IconListWrapper = styled(Flex)`
  .icon-linking {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease;
    cursor: pointer;
    &:hover {
      transform: translateY(-3px);
    }
  }
`
const IconWrapper = styled(Link)``
